import React, { useState } from 'react';

export default function MessageItem (props) {
    const { message, index, read, uid, readTime} = props;
    const [showTime, setShowTime] = useState(false);
    const messDate = new Date(message.date * 1000);
    const currentTime = Date.now();
    const timeDiff = (currentTime - readTime)
    const timeDiffMinutes = Math.floor(timeDiff / 60000)
    const timeDiffHours = Math.floor(timeDiff / 3600000)
    const timeDiffDays = Math.floor(timeDiffHours / 24)
    const timeDiffMonth = Math.floor(timeDiffDays / 30)
    const timeDiffYear = Math.floor(timeDiffMonth / 12) 
    const hour = messDate.getHours();
    const minutes = (messDate.getMinutes() < 10 && '0') + messDate.getMinutes();   
    const time = hour + ':' + minutes;
    let my = false
    if (uid === message.from){my = true}
    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div className={my ? "myMessage" : "message"} 
          style={{
            flexDirection: 'column', 
            display: 'flex',  
            marginBlockStart: showTime && 25, 
            cursor: 'pointer',
          }} 
          onClick={() => {showTime ? setShowTime(false) : setShowTime(true);  console.log(message.read, message)}}  
        >
          {my && showTime && <p style={{ position: 'absolute', top: -20,  fontSize: 12, alignSelf: 'end', color: '#803838'}}>{time}</p>}
          {my !== true && showTime && <p style={{ position: 'absolute', top: -20, fontSize: 12, alignSelf: 'start', color: '#424051'}}>{time}</p>}
          <p style={{marginInline: 5}}>{message.text}</p>
        </div>
        <div style={{textAlign: 'end', paddingInline: 15}}>
          {index === read && <p style={{color: 'var(--ltg)'}}>
          Read 
          {(timeDiffYear >= 1) ? (' ' + timeDiffYear + ' years ') :
          (timeDiffMonth >= 1 && timeDiffMonth < 12) ? (' ' + timeDiffMonth + ' months ') :
          (timeDiffDays >= 1 && timeDiffDays < 32) ? (' ' + timeDiffDays + ' days ') :
          (24 > timeDiffHours && timeDiffHours >= 1) ? (' ' + timeDiffHours + ' hours ') :
          (timeDiffHours < 1 && timeDiffMinutes >= 1) ? (' ' + timeDiffMinutes + ' minutes ') : 
          (timeDiffMinutes < 1 && ' less than a minute ') } 
          ago
          </p>}  
        </div>  
      </div>
    ) 
  }